import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import FirmSection from 'components/FirmSection';
import HtmlContentBlock from 'components/HtmlContentBlock';
import FirmStrategyFeatures from 'scenes/FirmStrategy/components/FirmStrategyFeatures';
import Collapsable from 'components/Collapsable';

const FirmStrategyInvestmentSection = props => {
  const {
    isEditMode,
    data,
    onEditInvestmentStrategy,
    onDeleteInvestmentStrategy,
  } = props;

  const [title, content, features] = useMemo(() => {
    if (data) {
      return [
        data.Title,
        data.Content,
        Object.keys(data).reduce((a, k) => {
          if (!['FirmStrategyID', 'FirmID', 'Title', 'Content'].includes(k)) {
            a[k] = { title: k.split(/(?=[A-Z])/).join(' '), value: data[k] };
          }
          return a;
        }, {}),
      ];
    }

    return ['Investment Strategy', '', []];
  }, [data]);

  return isEditMode ? (
    <FirmSection
      title={title}
      controls={
        data && data.FirmStrategyID
          ? [
              { caption: 'Edit', handler: onEditInvestmentStrategy },
              { caption: 'Delete', handler: onDeleteInvestmentStrategy },
            ]
          : [{ caption: 'Edit', handler: onEditInvestmentStrategy }]
      }
    >
      <div className="firm-strategy__text">
        <HtmlContentBlock content={content} />
      </div>

      {Object.keys(features).length > 0 && (
        <div className="firm-strategy__features">
          <FirmStrategyFeatures data={features} />
        </div>
      )}
    </FirmSection>
  ) : content ? (
    <FirmSection title={title}>
      <div className="firm-strategy__text">
        <Collapsable
          btnHidden={content.split(/\r\n|\r|\n/).length <= 5}
          maskHidden={content.split(/\r\n|\r|\n/).length <= 5}
        >
          <HtmlContentBlock content={content} />
        </Collapsable>
      </div>

      {Object.keys(features).length > 0 && (
        <div className="firm-strategy__features">
          <FirmStrategyFeatures data={features} />
        </div>
      )}
    </FirmSection>
  ) : null;
};

FirmStrategyInvestmentSection.propTypes = {
  isEditMode: PropTypes.bool.isRequired,
  data: PropTypes.shape({
    FirmStrategyID: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    Title: PropTypes.string,
    Content: PropTypes.string,
    OwnershipStyle: PropTypes.string,
    CompanySize: PropTypes.string,
    InvestmentSize: PropTypes.string,
    Geography: PropTypes.string,
    IndustrySectors: PropTypes.string,
    TransactionTypes: PropTypes.string,
  }),
  onEditInvestmentStrategy: PropTypes.func,
  onDeleteInvestmentStrategy: PropTypes.func,
};

export default FirmStrategyInvestmentSection;
